import React from 'react';
import { useQuery } from '@apollo/client';
import ReactSelect from 'components/Fields/ReactSelect';
import { Field } from 'formik';
import { COUNTRY_LISTS } from 'pages/MarketListing/MarketListingGraphQL';
import Loader from 'components/common/Loader';

const CountryField = ({ name, label, id, required = false, ...rest }) => {
  const {
    data: countryCurrencies,
    loading,
    error,
  } = useQuery(COUNTRY_LISTS, {
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader size="sm" />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Field
        id={id}
        label={label}
        name={name}
        type="select"
        component={ReactSelect}
        data={countryCurrencies?.countryCurrencies || []}
        required={required}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.country}
        {...rest}
      />
    </div>
  );
};

export default CountryField;
